import { updateOffer as _updateOffer } from 'src/thirdweb/dotc'
import useDotcContract from '../useDotcContract'
import { UpdatableOfferFields } from './types'
import { buildUpdatedOffer } from './utils'

const useUpdateOffer = () => {
  const dotcContract = useDotcContract()

  const updateOffer = (offerId: string, update: UpdatableOfferFields) => {
    if (!dotcContract) return

    const updateOfferTx = _updateOffer({
      contract: dotcContract,
      offerId: BigInt(offerId),
      updatedOffer: buildUpdatedOffer(update),
    })

    return updateOfferTx
  }

  return {
    updateOffer,
  }
}

export default useUpdateOffer
